export default __webpack_public_path__ + "static/media/logoBlack.e06708e0.png";